// extracted by mini-css-extract-plugin
export default {"investActiveFund":"InvestActiveFund_investActiveFund__u5wPw","management":"InvestActiveFund_management__rc4ai","listCurrensy":"InvestActiveFund_listCurrensy__kqrxs"};